
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stablecoin",
      function () {
        return require("private-next-pages/stablecoin.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stablecoin"])
      });
    }
  